import "./GalleriePage.css"; 
import HeroTitle from "../../layouts/HeroTitle/HeroTitle";
import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExpand, faTimes } from "@fortawesome/free-solid-svg-icons";
import { ApiService } from '../../services/api.service';
import { toast } from 'react-toastify';
import { getBackendImageUrl } from '../../utils/imageUtils';

function GalleriePage() {
    const [selectedImage, setSelectedImage] = useState(null);
    const [galleryImages, setGalleryImages] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchGalleryImages = async () => {
            try {
                const images = await ApiService.getGalleryItems();
                setGalleryImages(images);
            } catch (error) {
                toast.error('Erreur lors du chargement de la galerie');
                console.error('Erreur:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchGalleryImages();
    }, []);

    if (isLoading) {
        return (
            <>
                <HeroTitle title="GALERIE" />
                <div className="loading-container">
                    <p>Chargement de la galerie...</p>
                </div>
            </>
        );
    }

    return (
        <>
            <HeroTitle title="GALERIE" />
            <section className="gallery-section">
                <div className="container">
                    <div className="gallery-grid">
                        {galleryImages.map((image) => (
                            <div key={image.id} className="gallery-item">
                                <img src={getBackendImageUrl(image.imageUrl)} alt={image.title} />
                                <div className="gallery-overlay" onClick={() => setSelectedImage(image)}>
                                    <FontAwesomeIcon icon={faExpand} className="expand-icon" />
                                    <p>{image.title}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {selectedImage && (
                    <div className="lightbox" onClick={() => setSelectedImage(null)}>
                        <button className="close-button" onClick={() => setSelectedImage(null)}>
                            <FontAwesomeIcon icon={faTimes} />
                        </button>
                        <img src={getBackendImageUrl(selectedImage.imageUrl)} alt={selectedImage.title} />
                        <p className="lightbox-caption">{selectedImage.title}</p>
                        {selectedImage.description && (
                            <p className="lightbox-description">{selectedImage.description}</p>
                        )}
                    </div>
                )}
            </section>
        </>
    );
}

export default GalleriePage;